import api from '../../../api/apibackend'
import Nprogress from 'nprogress'
import Vue from 'vue'
import {
  GET_STORE_CATEGORIES,
} from './actions.type'
import { FETCH_START, FETCH_END, SET_STORE_CATEGORIES } from './mutations.type'

const state = {
  storeCategories: null,
  loadingStoreCategories: false,
}

const getters = {
  storeCategories: state => (state.storeCategories ? state.storeCategories : []),
  loadingStoreCategories: state => state.loadingStoreCategories,
}

const mutations = {
  [SET_STORE_CATEGORIES](state, storeCategories) {
    state.storeCategories = storeCategories
  },
  [FETCH_START](state) {
    Nprogress.start()
    state.loadingStoreCategories = true
  },
  [FETCH_END](state) {
    Nprogress.done()
    state.loadingStoreCategories = false
  }
}

const actions = {
  async [GET_STORE_CATEGORIES]({ commit }) {
    try {
      commit(FETCH_START)
      const res = await api.get(`categories`)
      commit(SET_STORE_CATEGORIES, res.data)
      commit(FETCH_END)
      return res.data
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}
